// extracted by mini-css-extract-plugin
export var wordContainer = "_s4-0";